import React from 'react';
import styleDomanda from './Domanda.module.scss';
import { Radio, Form } from 'antd';

const Domanda = props => {
  return (
    <div
      className={`${styleDomanda.Domanda} ${String(props.domandaAttuale) === props.numeroDomanda ? `${styleDomanda.show}` : `${styleDomanda.hidden}`}`}>
      <h2 className={styleDomanda.headerModale}>
        Questionario per valutare se il prodotto assicurativo è coerente con i
        tuoi bisogni e le tue esigenze di copertura.
      </h2>

      <p className={styleDomanda.numeroDomanda}>
        Domanda {props.numeroDomanda}
      </p>
      <p className={styleDomanda.testoDomanda}>{props.testoDomanda}</p>

      {/* {

                    props.numeroDomanda === '2' ? (
                        <>
                        <h2 className={styleDomanda.subTitle2}>
                            Vuoi acquistare un’assicurazione che ti protegge in caso di decesso o gravi malattie*?
                        </h2>
                        <p className={styleDomanda.subText2}>
                            *Gravi malattie incluse nella copertura sono: cancro, ictus, infarto, insufficienza renale cronica, intervento chirurgico da malattia dell'arteria coronaria, trapianto di cuore, polmone, fegato, pancreas o midollo osseo. 
                        </p>
                        </>
                    ) : (
                    <p className={styleDomanda.testoDomanda}>{props.testoDomanda}</p>
                    )
                
                } */}
      <Form.Item
        name={props.nameDomanda}
        rules={[
          {
            required: true,
            message: 'Accetta o nega il consenso',
          },
        ]}>
        <Radio.Group name={props.nameDomanda} onChange={props.cambioDomanda}>
          <Radio.Button value={true}>Sì</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </Form.Item>

      {/* 
                {
                    props.numeroDomanda === '3' ? (
                    
                        <p className={styleDomanda.testofooterDomanda}>INFORMAZIONE IMPORTANTE: le garanzie decesso, invalidità permanente totale di grado pari o superiore al 60%, inabilità temporanea totale e ricovero ospedaliero sono prestate esclusivamente a seguito di infortunio</p>
                    
                    ) : null
                } */}
    </div>
  );
};

export default Domanda;
